export default "__VITE_ASSET__CAinvGDq__"